import { useEcoClient, useEcoMutation } from "hooks"

export const useBuyQuery = () => {

    const ecoClient = useEcoClient()
    
    return useEcoMutation<BuyResponse, any>((payload: BuyParam) => {
        return ecoClient.post<BuyResponse>({
            path : 'braintree/buy',
            data: {},
            config: {
                params : payload
            }
        })
    })

}

type BuyResponse = {
    transactionId: string,
    customerorderId: number
}

type BuyParam = {
    braintreeNonce: any,
    totalAmount: number,
    cartToken: string,
    deviceData?: string
}
